<script>
import { epaSectors as _API_ } from "./api-calls";

export default {
    data() {
        return {
            data: [],

            selectedLanguage: 'en',
            languages: [
                { value: 'en', text: 'EN' },
                { value: 'tr', text: 'TR' },
            ],

            headers: [
                {
                    key: '#',
                    in: 'index',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    }
                },
                {
                    key: 'text',
                    in: 'text_data',
                    style: {
                        'flex': 3,
                        'text-align': 'left'
                    }
                },
            ],

            createData: undefined,
            editData: undefined,
        }
    },

    computed: {

    },

    async mounted() {
        await this.fetchRequest();
    },

    methods: {
        async fetchRequest() {
            await _API_.fetch()
                .then(res => {
                    this.data = res.data;
                })
        },
        
        async createRequest() {
            const params = {
                id: undefined,
                body: this.createData
            };

            await _API_.create(params)
                .then(res => {
                    this.data.push(
                        {
                            main_data: {
                                id: res.data.value,
                                created_by: this.$user.user_id,
                                created_on: new Date(),
                                ...this.createData.main_data
                            },
                            text_data: this.createData.text_data
                        }
                    );

                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        async updateRequest() {
            const params = {
                id: this.editData.main_data.id,
                body: this.editData
            };
            await _API_.update(params)
                .then(res => {
                    this.editData.updated_by = this.$user.user_id,
                    this.editData.updated_on = new Date(),
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        async deleteRequest() {
            const params = {
                id: this.editData.main_data.id,
                body: undefined
            };
            await _API_.delete(params.id)
                .then(res => {
                    this.editData.main_data.is_deleted = true;
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(() => {
                    this.$refs.editPopup.startHideProcess();
                })
        },

        async handleClickCreate() {
            await this.setupCreateData();
            this.$refs.createPopup.openPopup();
        },

        async setupCreateData() {
            this.createData = {
                main_data: {
                    
                },
                text_data: {
                    tr: null,
                    en: null,
                },
            };
        },

        async handleClickEdit(item) {
            await this.setupEditData(item);
            this.$refs.editPopup.openPopup();
        },

        async setupEditData(item) {
            this.editData = item;
        },
    }
}
</script>

<template>
    <div class="flex-all-centered-col main-frame">
        <tab-selector 
            :options="languages" 
            :selectedTab="selectedLanguage" 
            @select-tab="($event) => selectedLanguage = $event.value"
        />

        <div class="table small-box-shadow">
            <div class="table-row headers">
                <div v-for="h in headers" :key="h.key"
                    :style="h.style"
                >
                    {{ $t(`carbon-admin.headers.${h.key}`) }}
                </div>
            </div>
    
            <div v-for="(item, idx) in data" :key="idx"
                v-show="!item.main_data.is_deleted"
                class="table-row values"
                @click="handleClickEdit(item)"
            >
                <div v-for="h in headers" :key="h.key"
                    :style="h.style"
                >
                    <span v-if="h.in === 'index'">
                        {{ idx+1 }}
                    </span>
                    <span v-else-if="h.in === 'text_data'">
                        {{ item.text_data[selectedLanguage] }}
                    </span>
                    <span v-else>
                        {{ item.main_data[h.key] }}
                    </span>
                </div>
            </div>
        </div>

        <div class="flex-all-centered-row" style="justify-content: flex-end;">
            <button class="sust-btn sust-btn-green"
                @click="handleClickCreate()"
            >
                {{ $t('misc.create-new') }}
            </button>
        </div>

        <sust-popup ref="createPopup"
            size="md"
            :header="false"
            @ok="createRequest()"
            @onHide="() => createData = undefined"
        >
            <div v-if="createData" 
                class="flex-all-centered-col"
            >
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.text') }} (EN)
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="createData.text_data.en"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.text') }} (TR)
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="createData.text_data.tr"
                    >
                </div>
            </div>
        </sust-popup>
        
        <sust-popup ref="editPopup"
            size="md"
            :header="false"
            @ok="updateRequest()"
            @onHide="() => editData = undefined"
        >
            <div v-if="editData" 
                class="flex-all-centered-col"
            >
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.text') }} (EN)
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="editData.text_data.en"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.text') }} (TR)
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="editData.text_data.tr"
                    >
                </div>
            </div>

            <template #footer="{ hide }">
                <div class="flex-all-centered-row"
                    style="justify-content: space-between; padding: .5em;"
                >
                    <button class="sust-btn sust-btn-red"
                        @click="() => {
                            $refs.deletePopup.openPopup()
                        }"
                    >
                        {{ $t('misc.delete') }}
                    </button>

                    <div class="flex-all-centered-row"
                        style="justify-content: flex-end;"
                    >
                        <button class="sust-btn sust-btn-red"
                            @click="hide()"
                        >
                            {{ $t('misc.cancel') }}
                        </button>
                        <button class="sust-btn sust-btn-green"
                            style="margin-left: 1em;"
                            @click="() => {
                                updateRequest(); 
                                hide();
                            }"
                        >
                            {{ $t('misc.save') }}
                        </button>
                    </div>
                </div>
            </template>
        </sust-popup>

        <sust-popup ref="deletePopup"
            size="sm"
            :title="$t('carbon-admin.titles.delete')"
            @ok="deleteRequest()"
        >
            {{ $t('carbon-admin.warnings.delete') }}
        </sust-popup>
    </div>
</template>

<style lang='scss' scoped>
@import "../../../assets/css/carbon-admin-page.scss";
</style>